export class TrainingPrice {
    id: number;
    training: number;
    city: string;
    country: string;
    countryCode: string;
    price: number;
    currencyCode: string;
}



// WEBPACK FOOTER //
// ./src/app/_services/training/location/price.model.ts